/*******************************************************************************
 * Copyright (c) 2025 Bula Technologies
 *
 * All rights reserved.
 *
 * Contributors:
 *  James Worthington - Initial implementation
 *  Amina Rais - Massive Improvements
 *  Version: 1.0.0
 *
 *******************************************************************************/


import React from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import Contactus from '../../../components/Views/public/Contactus' 

 
class ContactusPage extends React.Component {
  componentDidMount() {
    window.scrollTo(0, 0);

  }
  render() {
    return (
      <> 
        <Contactus />
      </>
    )
  }
}

ContactusPage.propTypes = {
  classes: PropTypes.object.isRequired,
}

function mapStateToProps() {
  return {}
}

const styledContactusPage = ContactusPage
const connectedContactusPage = connect(mapStateToProps)(styledContactusPage)
export { connectedContactusPage as ContactusPage }
